import { render, staticRenderFns } from "./ModalDownloadConfig.vue?vue&type=template&id=0420ec42"
import script from "./ModalDownloadConfig.vue?vue&type=script&lang=js"
export * from "./ModalDownloadConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports